var map = {
	"./Jcrop.gif": 3726,
	"./backgrounds/agenda.webp": 6645,
	"./backgrounds/agenda_md.webp": 3123,
	"./backgrounds/augsburg_fountain.webp": 3295,
	"./backgrounds/augsburg_fountain_md.webp": 8598,
	"./backgrounds/augsburg_fountain_xl.webp": 2598,
	"./backgrounds/augsburg_panorama.webp": 5147,
	"./backgrounds/augsburg_panorama_lg.webp": 7957,
	"./backgrounds/augsburg_panorama_md.webp": 2111,
	"./backgrounds/augsburg_panorama_xl.webp": 4784,
	"./backgrounds/augsburg_rathausplatz.webp": 7463,
	"./backgrounds/augsburg_rathausplatz_xl.webp": 59,
	"./backgrounds/augsburg_statues.webp": 2412,
	"./backgrounds/augsburg_statues_md.webp": 9784,
	"./backgrounds/augsburg_statues_xl.webp": 366,
	"./backgrounds/chair.webp": 1097,
	"./backgrounds/chair_xl.webp": 3212,
	"./backgrounds/login_banner.png": 7810,
	"./backgrounds/login_banner_smaller.png": 4517,
	"./backgrounds/map.webp": 1930,
	"./backgrounds/members.webp": 8671,
	"./backgrounds/members_xl.webp": 8445,
	"./backgrounds/mountains.webp": 1201,
	"./backgrounds/mountains_xl.webp": 4801,
	"./company_logo.png": 2418,
	"./conlance_info.png": 8811,
	"./conlance_logo.png": 9424,
	"./conlance_logo.svg": 1910,
	"./conlance_logo_mobile.svg": 941,
	"./conlance_logo_slogan.svg": 515,
	"./favicon.ico": 9409,
	"./header-image-1.5.jpg": 1029,
	"./header-image-750.jpg": 581,
	"./icons/handshake.webp": 374,
	"./icons/thumbsup.webp": 5356,
	"./icons/unity.webp": 8011,
	"./mu-blue.png": 4614,
	"./mu-logo-textless.png": 1008,
	"./mu-logo-white.png": 5783,
	"./mu-logo.png": 3013,
	"./party/person.webp": 6166,
	"./placeholder-150-logo.png": 6943,
	"./placeholder-300-logo.png": 9831,
	"./placeholder-logo.svg": 1417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7647;